// i18n 最小初始化(spec 260508-folder-feature / plan §4.1)。
//
// - 资源静态打包(`./locales/<lang>.json`),不引入 backend / http 加载。
// - locale 来自 navigator.language;命中 zh-* 用 zh-CN,命中 en-* 用 en-US,
//   其他一律 fallback 到 zh-CN(项目当前默认中文)。
// - 入口要求:必须在 ReactDOM.createRoot 之前 import 这个模块,否则
//   useTranslation() 在第一帧渲染时会拿到 key 字面量。
//
// 后续若引入语言切换 UI,从 useSessionStore 中读 user.locale 调
// `i18n.changeLanguage(...)` 即可,不需要改这里。

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './locales/en-US.json';
import zhCN from './locales/zh-CN.json';

function pickInitialLanguage(): 'zh-CN' | 'en-US' {
  // jsdom / 老版本 Node 可能没 navigator
  const lang =
    typeof navigator !== 'undefined' && typeof navigator.language === 'string'
      ? navigator.language
      : 'zh-CN';
  if (lang.toLowerCase().startsWith('en')) return 'en-US';
  return 'zh-CN';
}

void i18next.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
  },
  lng: pickInitialLanguage(),
  fallbackLng: 'zh-CN',
  interpolation: {
    // React 已自带 XSS 防护,不需要 i18next escape。
    escapeValue: false,
  },
  // 项目尚无 namespace 切分需求,默认 'translation' 即可。
  defaultNS: 'translation',
  // 测试中可能多次 import,不要在已 init 时再跑一次 init。
  initImmediate: false,
});

export default i18next;
